import ReportHeatmapTable from "../../../../../../components/reports/report-heatmap-table/report-heatmap-table.jsx";

export default function EncounterWeekday({ data }) {
    return (
        <ReportHeatmapTable
            data={data?.encountersByWeekDayTable ?? []}
            title="Abordagens por dia da semana com intervalo de 1 hora"
            sheetName="Abordagens por dia da semana"
            tableId="encounter-by-weekday-table"
            rowLabelKey="hour"
            rowPeriodKey="t"
            minKey="min"
            maxKey="max"
            columns={[
                { key: "segunda", label: "Segunda" },
                { key: "terca", label: "Terça" },
                { key: "quarta", label: "Quarta" },
                { key: "quinta", label: "Quinta" },
                { key: "sexta", label: "Sexta" },
                { key: "sabado", label: "Sábado" },
                { key: "domingo", label: "Domingo" },
            ]}
        />
    )
}